import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEnter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEnter"><Path d="M20.5 3.5V10.5V20.5H10.5H3.5L3.5 9.5H9.5V3.5L20.5 3.5Z" stroke="currentColor"/><Path d="M15 9.5V15H10" stroke="currentColor"/><Path d="M11 12.5L7.5 15L11 17.5V15V12.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEnter;
